export enum NucleofectionInternalAction {
  SET_SELECTED_INTERMEDIATE_WELLS,
  SET_NEXT_STEP,
  SET_PREV_STEP,
  SET_WORKLIST,
  SET_WORKLIST_PREVIEW_OPEN,
  UPDATE_METHOD_SETTINGS,
  SET_UPLOADED_NUCLEOFECTION_PLATE,
  SET_SELECTED_NUCLEOFECTION_WELLS,
  SET_DEST_SELECTION_PROCESS,
  SET_HOVER_WELL_ID,
  SET_OPTIONAL_WARNINGS,
  SET_REQUIRED_WARNINGS,
  UPDATE_METHOD_SETTINGS_FROM_UPLOAD,
  SET_STATE,
  SET_NUCLEOFECTION_ALREADY_RESERVED,
}

export interface INucleofectionInternalAction {
  payload: any;
  type: NucleofectionInternalAction;
}
